var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.8074 119.615C26.8297 119.615 0 92.785 0 59.8073C0 26.8297 26.8297 0 59.8074 0C92.7851 0 119.615 26.8297 119.615 59.8073C119.615 92.785 92.7851 119.615 59.8074 119.615Z",
    fill: "url(#paint0_linear_1311_15347)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3166 30.8285C87.8707 27.3066 80.6243 26.6598 77.2652 30.8285C71.4847 38.003 65.7036 45.1775 59.9231 52.352C57.1706 55.7685 54.4182 59.1849 51.6651 62.6014C50.6883 63.8143 49.5252 65.6333 48.2574 67.3223C48.0096 67.0672 47.7612 66.8119 47.5127 66.557C45.6447 64.6371 43.7765 62.7171 41.9083 60.7973C32.9737 51.6158 18.9281 65.6741 27.8563 74.849C32.466 79.5857 37.1739 86.2071 43.4239 88.706C50.2776 91.4468 56.3563 88.1487 60.762 82.8027C71.0843 70.2782 81.134 57.5183 91.3166 44.8802C94.7081 40.6708 95.3536 34.9553 91.3166 30.8285Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8594 7.14627C63.7794 1.54695 27.8118 0.193758 9.52539 35.8611C26.7254 15.221 45.3562 4.79262 76.8594 7.14627Z",
    fill: "#BDDE23"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8088 114.07C78.1913 111.875 99.205 94.0988 113.743 72.6592C111.393 86.0223 102.363 98.295 91.4221 105.846C80.4807 113.398 63.4894 118 47.6621 114.07",
    fill: "#15A208"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1311_15347",
    x1: 33.5,
    y1: -0.281252,
    x2: 95.5,
    y2: 119.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83D519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17A308"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.54403f94aba51c2fcc9afa1474c2669c.svg";
export { ForwardRef as ReactComponent };